module.exports = __webpack_public_path__ + "static/img/quotes_banner.6e3f784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quotes_banner.png
// module id = uQ59
// module chunks = 3